import { Navigate, Outlet } from "react-router-dom";
import { useAuthInfo } from "@/hooks/use-auth-info";
import { Navbar } from "../navbar";
import { Sidenav } from "../sidenav";

export function AuthedOutlet() {
	const { user, isAuthed, isLoading } = useAuthInfo();

	if (isLoading) {
		return null;
	}

	if (!isLoading && (!user || !isAuthed)) {
		return <Navigate to="/login" />;
	}

	return (
		<div className="p-4">
			<Navbar />
			<div className="flex flex-col md:flex-row">
				{/* Sidebar - top on mobile, left on desktop */}
				<aside className="p-4 md:w-48">
					<Sidenav />
				</aside>

				{/* Main content - below nav on mobile, right side on desktop */}
				<main className="flex-1 p-4">
					<Outlet />
				</main>
			</div>
		</div>
	);
}
